import { Tag as AntTag } from 'antd';
import React, { memo } from 'react';

import { INTERNAL_ADMIN_ROLE_TO_LABEL, InternalAdminRole } from 'constants/internal-admin-roles';
import { UserRole, UserRoleLabels } from 'types/models/membership';

import './UserRoleTag.less';

type UserRoleTagProps = {
  /** Raw value of enterprise membership or internal-admin role (e.g. `view-only`, `super-admin`). */
  role: string;
};

function getLabel(role: string): string {
  return (
    INTERNAL_ADMIN_ROLE_TO_LABEL[role as InternalAdminRole]
    ?? UserRoleLabels[role as UserRole]
    ?? role
  );
}

/** @see https://www.figma.com/design/Vvl7WmeGXXmS948pRsQNKE/Farmbot-Outback-Design-System?node-id=871-2267 */
function UserRoleTag({ role }: UserRoleTagProps): JSX.Element {
  return <AntTag className="UserRoleTag">{getLabel(role).toUpperCase()}</AntTag>;
}

export default memo(UserRoleTag);
export type { UserRoleTagProps };
